import React, { PureComponent } from 'react';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import config from './Banner.component.config';
import './Banner.less';

class Banner extends PureComponent {
  render() {
    const { imgSource } = this.props;

    if (imgSource.length > 1) {
      return (
        <Carousel
          infiniteLoop
          autoPlay
          showArrows={false}
          showThumbs={false}
          showStatus={false}
        >
          {imgSource.map((image, index) => (
            <img src={image} alt="" width="100%" key={`image_${index + 1}`} />
          ))}
        </Carousel>
      );
    }
    return <img src={imgSource} alt="" width="100%" />;
  }
}

Banner.displayName = config.displayName;
Banner.propTypes = config.propTypes;
Banner.defaultProps = config.defaultProps;

export default Banner;
